import React, { useState, useEffect } from "react";
import EmployeeMaleimage from "../../Assets/employeelistimage.svg";
import Navbar from "../../Components/Navbar";
import { getInsytixEmployees } from "../../api/InsytixEmployees";
import Cards from "../../Components/Cards";

import { useAuthContext } from "../../hooks";
import EmployeeDirectorySc from "./index.sc";
function Index() {
  const [users, Setusers] = useState<any[]>([]);
  const auth = useAuthContext();
  const orgId = auth?.userInfo?.orgs?.[0]?.id || 100000000001;
  const fetchAllUsers = async () => {
    const rows = await getInsytixEmployees(orgId);
    Setusers(Array.isArray(rows) ? rows : []);
  };
  useEffect(() => {
    fetchAllUsers();
  }, [orgId]);
  const [show, setShow] = useState(false);

  return (
    <EmployeeDirectorySc>
      <div className="employee_directory_x_container">
        <div className="employee-container">
          <div className="emp-table">
            <table>
              <tr>
                <th className="heading">Name</th>
                <th className="heading">Employee Id</th>
                <th className="heading">Email</th>
                <th className="heading">Designation</th>
              </tr>
              {users &&
                users?.map((data: any) => {
                  return (
                    <>
                      <tr>
                        <td>{data?.Name}</td>
                        <td>{data?.employee_id}</td>
                        <td>{data?.c_mail || ""}</td>
                        <td>{data?.designation || ""}</td>
                      </tr>
                    </>
                  );
                })}
            </table>
          </div>
        </div>
      </div>
    </EmployeeDirectorySc>
  );
}

export default Index;
